import React from 'react';
import TeamManager from '../Components/Society/TeamManager';
import { Navbar, Footer } from '../Components/Home/layout';

const TeamPage = () => (
  <>
    <Navbar />
    <TeamManager />
    <Footer />
  </>
);

export default TeamPage;
